/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AddressBookItem } from '../models/address-book-item';
import { AddressBookListResponse } from '../models/address-book-list-response';
import { BaseResponse } from '../models/base-response';
import { CompantOfficeTypeListResposne } from '../models/compant-office-type-list-resposne';
import { CompanyOfficeItem } from '../models/company-office-item';
import { CompanyOfficeListResponse } from '../models/company-office-list-response';
import { CompanyOfficeTypeItem } from '../models/company-office-type-item';
import { EmptyResponse } from '../models/empty-response';
import { officeControllerAssociateOfficesToUser } from '../fn/company-offices/office-controller-associate-offices-to-user';
import { OfficeControllerAssociateOfficesToUser$Params } from '../fn/company-offices/office-controller-associate-offices-to-user';
import { officeControllerAssociateUsersToOffice } from '../fn/company-offices/office-controller-associate-users-to-office';
import { OfficeControllerAssociateUsersToOffice$Params } from '../fn/company-offices/office-controller-associate-users-to-office';
import { officeControllerCreateAddressBookOfanoffice } from '../fn/company-offices/office-controller-create-address-book-ofanoffice';
import { OfficeControllerCreateAddressBookOfanoffice$Params } from '../fn/company-offices/office-controller-create-address-book-ofanoffice';
import { officeControllerCreateOfficeType } from '../fn/company-offices/office-controller-create-office-type';
import { OfficeControllerCreateOfficeType$Params } from '../fn/company-offices/office-controller-create-office-type';
import { officeControllerDeleteAddressBook } from '../fn/company-offices/office-controller-delete-address-book';
import { OfficeControllerDeleteAddressBook$Params } from '../fn/company-offices/office-controller-delete-address-book';
import { officeControllerDeleteOfficeType } from '../fn/company-offices/office-controller-delete-office-type';
import { OfficeControllerDeleteOfficeType$Params } from '../fn/company-offices/office-controller-delete-office-type';
import { officeControllerDissociateOfficesFromUser } from '../fn/company-offices/office-controller-dissociate-offices-from-user';
import { OfficeControllerDissociateOfficesFromUser$Params } from '../fn/company-offices/office-controller-dissociate-offices-from-user';
import { officeControllerDissociateUsersFromOffice } from '../fn/company-offices/office-controller-dissociate-users-from-office';
import { OfficeControllerDissociateUsersFromOffice$Params } from '../fn/company-offices/office-controller-dissociate-users-from-office';
import { officeControllerFind } from '../fn/company-offices/office-controller-find';
import { OfficeControllerFind$Params } from '../fn/company-offices/office-controller-find';
import { officeControllerFindAllAddressBookByOffice } from '../fn/company-offices/office-controller-find-all-address-book-by-office';
import { OfficeControllerFindAllAddressBookByOffice$Params } from '../fn/company-offices/office-controller-find-all-address-book-by-office';
import { officeControllerFindAllOfficeTypes } from '../fn/company-offices/office-controller-find-all-office-types';
import { OfficeControllerFindAllOfficeTypes$Params } from '../fn/company-offices/office-controller-find-all-office-types';
import { officeControllerFindOne } from '../fn/company-offices/office-controller-find-one';
import { OfficeControllerFindOne$Params } from '../fn/company-offices/office-controller-find-one';
import { officeControllerFindOneAddressBook } from '../fn/company-offices/office-controller-find-one-address-book';
import { OfficeControllerFindOneAddressBook$Params } from '../fn/company-offices/office-controller-find-one-address-book';
import { officeControllerRegisterOfficeToCompany } from '../fn/company-offices/office-controller-register-office-to-company';
import { OfficeControllerRegisterOfficeToCompany$Params } from '../fn/company-offices/office-controller-register-office-to-company';
import { officeControllerUpdateAddressBook } from '../fn/company-offices/office-controller-update-address-book';
import { OfficeControllerUpdateAddressBook$Params } from '../fn/company-offices/office-controller-update-address-book';
import { officeControllerUpdateOffice } from '../fn/company-offices/office-controller-update-office';
import { OfficeControllerUpdateOffice$Params } from '../fn/company-offices/office-controller-update-office';
import { officeControllerUpdateOfficeType } from '../fn/company-offices/office-controller-update-office-type';
import { OfficeControllerUpdateOfficeType$Params } from '../fn/company-offices/office-controller-update-office-type';

@Injectable({ providedIn: 'root' })
export class CompanyOfficesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `officeControllerFindAllOfficeTypes()` */
  static readonly OfficeControllerFindAllOfficeTypesPath = '/company/office/types';

  /**
   * Lista tipi ufficio.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `officeControllerFindAllOfficeTypes()` instead.
   *
   * This method doesn't expect any request body.
   */
  officeControllerFindAllOfficeTypes$Response(params?: OfficeControllerFindAllOfficeTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CompantOfficeTypeListResposne;
}>> {
    const obs = officeControllerFindAllOfficeTypes(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Lista tipi ufficio.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `officeControllerFindAllOfficeTypes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  officeControllerFindAllOfficeTypes(params?: OfficeControllerFindAllOfficeTypes$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: CompantOfficeTypeListResposne;
}> {
    const resp = this.officeControllerFindAllOfficeTypes$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: CompantOfficeTypeListResposne;
}>): BaseResponse & {
'data'?: CompantOfficeTypeListResposne;
} => r.body)
    );
  }

  /** Path part for operation `officeControllerCreateOfficeType()` */
  static readonly OfficeControllerCreateOfficeTypePath = '/company/office/type';

  /**
   * Crea un tipo di ufficio.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `officeControllerCreateOfficeType()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  officeControllerCreateOfficeType$Response(params: OfficeControllerCreateOfficeType$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CompanyOfficeTypeItem;
}>> {
    const obs = officeControllerCreateOfficeType(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Crea un tipo di ufficio.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `officeControllerCreateOfficeType$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  officeControllerCreateOfficeType(params: OfficeControllerCreateOfficeType$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: CompanyOfficeTypeItem;
}> {
    const resp = this.officeControllerCreateOfficeType$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: CompanyOfficeTypeItem;
}>): BaseResponse & {
'data'?: CompanyOfficeTypeItem;
} => r.body)
    );
  }

  /** Path part for operation `officeControllerDeleteOfficeType()` */
  static readonly OfficeControllerDeleteOfficeTypePath = '/company/office/type/{id}';

  /**
   * Elimina un tipo di ufficio.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `officeControllerDeleteOfficeType()` instead.
   *
   * This method doesn't expect any request body.
   */
  officeControllerDeleteOfficeType$Response(params: OfficeControllerDeleteOfficeType$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CompanyOfficeTypeItem;
}>> {
    const obs = officeControllerDeleteOfficeType(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Elimina un tipo di ufficio.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `officeControllerDeleteOfficeType$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  officeControllerDeleteOfficeType(params: OfficeControllerDeleteOfficeType$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: CompanyOfficeTypeItem;
}> {
    const resp = this.officeControllerDeleteOfficeType$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: CompanyOfficeTypeItem;
}>): BaseResponse & {
'data'?: CompanyOfficeTypeItem;
} => r.body)
    );
  }

  /** Path part for operation `officeControllerUpdateOfficeType()` */
  static readonly OfficeControllerUpdateOfficeTypePath = '/company/office/type/{id}';

  /**
   * Aggiorna un tipo di ufficio.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `officeControllerUpdateOfficeType()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  officeControllerUpdateOfficeType$Response(params: OfficeControllerUpdateOfficeType$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CompanyOfficeTypeItem;
}>> {
    const obs = officeControllerUpdateOfficeType(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Aggiorna un tipo di ufficio.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `officeControllerUpdateOfficeType$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  officeControllerUpdateOfficeType(params: OfficeControllerUpdateOfficeType$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: CompanyOfficeTypeItem;
}> {
    const resp = this.officeControllerUpdateOfficeType$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: CompanyOfficeTypeItem;
}>): BaseResponse & {
'data'?: CompanyOfficeTypeItem;
} => r.body)
    );
  }

  /** Path part for operation `officeControllerFind()` */
  static readonly OfficeControllerFindPath = '/company/office/company/{id}';

  /**
   * Restituisce l'elenco degli uffici di un azienda.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `officeControllerFind()` instead.
   *
   * This method doesn't expect any request body.
   */
  officeControllerFind$Response(params: OfficeControllerFind$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CompanyOfficeListResponse;
}>> {
    const obs = officeControllerFind(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Restituisce l'elenco degli uffici di un azienda.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `officeControllerFind$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  officeControllerFind(params: OfficeControllerFind$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: CompanyOfficeListResponse;
}> {
    const resp = this.officeControllerFind$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: CompanyOfficeListResponse;
}>): BaseResponse & {
'data'?: CompanyOfficeListResponse;
} => r.body)
    );
  }

  /** Path part for operation `officeControllerFindOne()` */
  static readonly OfficeControllerFindOnePath = '/company/office/{id}';

  /**
   * Restituisce un ufficio.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `officeControllerFindOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  officeControllerFindOne$Response(params: OfficeControllerFindOne$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CompanyOfficeItem;
}>> {
    const obs = officeControllerFindOne(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Restituisce un ufficio.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `officeControllerFindOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  officeControllerFindOne(params: OfficeControllerFindOne$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: CompanyOfficeItem;
}> {
    const resp = this.officeControllerFindOne$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: CompanyOfficeItem;
}>): BaseResponse & {
'data'?: CompanyOfficeItem;
} => r.body)
    );
  }

  /** Path part for operation `officeControllerUpdateOffice()` */
  static readonly OfficeControllerUpdateOfficePath = '/company/office/{id}';

  /**
   * Modifica un ufficio.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `officeControllerUpdateOffice()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  officeControllerUpdateOffice$Response(params: OfficeControllerUpdateOffice$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CompanyOfficeItem;
}>> {
    const obs = officeControllerUpdateOffice(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Modifica un ufficio.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `officeControllerUpdateOffice$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  officeControllerUpdateOffice(params: OfficeControllerUpdateOffice$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: CompanyOfficeItem;
}> {
    const resp = this.officeControllerUpdateOffice$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: CompanyOfficeItem;
}>): BaseResponse & {
'data'?: CompanyOfficeItem;
} => r.body)
    );
  }

  /** Path part for operation `officeControllerRegisterOfficeToCompany()` */
  static readonly OfficeControllerRegisterOfficeToCompanyPath = '/company/office';

  /**
   * Crea un ufficio e lo associa all'azzienda.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `officeControllerRegisterOfficeToCompany()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  officeControllerRegisterOfficeToCompany$Response(params: OfficeControllerRegisterOfficeToCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CompanyOfficeItem;
}>> {
    const obs = officeControllerRegisterOfficeToCompany(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Crea un ufficio e lo associa all'azzienda.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `officeControllerRegisterOfficeToCompany$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  officeControllerRegisterOfficeToCompany(params: OfficeControllerRegisterOfficeToCompany$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: CompanyOfficeItem;
}> {
    const resp = this.officeControllerRegisterOfficeToCompany$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: CompanyOfficeItem;
}>): BaseResponse & {
'data'?: CompanyOfficeItem;
} => r.body)
    );
  }

  /** Path part for operation `officeControllerAssociateUsersToOffice()` */
  static readonly OfficeControllerAssociateUsersToOfficePath = '/company/office/associate/office/{id}/users';

  /**
   * Associa piu utenti ad un ufficio.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `officeControllerAssociateUsersToOffice()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  officeControllerAssociateUsersToOffice$Response(params: OfficeControllerAssociateUsersToOffice$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: EmptyResponse;
}>> {
    const obs = officeControllerAssociateUsersToOffice(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Associa piu utenti ad un ufficio.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `officeControllerAssociateUsersToOffice$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  officeControllerAssociateUsersToOffice(params: OfficeControllerAssociateUsersToOffice$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: EmptyResponse;
}> {
    const resp = this.officeControllerAssociateUsersToOffice$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: EmptyResponse;
}>): BaseResponse & {
'data'?: EmptyResponse;
} => r.body)
    );
  }

  /** Path part for operation `officeControllerDissociateUsersFromOffice()` */
  static readonly OfficeControllerDissociateUsersFromOfficePath = '/company/office/associate/office/{id}/users';

  /**
   * Dissocia piu utenti da un ufficio.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `officeControllerDissociateUsersFromOffice()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  officeControllerDissociateUsersFromOffice$Response(params: OfficeControllerDissociateUsersFromOffice$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: EmptyResponse;
}>> {
    const obs = officeControllerDissociateUsersFromOffice(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Dissocia piu utenti da un ufficio.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `officeControllerDissociateUsersFromOffice$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  officeControllerDissociateUsersFromOffice(params: OfficeControllerDissociateUsersFromOffice$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: EmptyResponse;
}> {
    const resp = this.officeControllerDissociateUsersFromOffice$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: EmptyResponse;
}>): BaseResponse & {
'data'?: EmptyResponse;
} => r.body)
    );
  }

  /** Path part for operation `officeControllerAssociateOfficesToUser()` */
  static readonly OfficeControllerAssociateOfficesToUserPath = '/company/office/associate/user/{id}/offices';

  /**
   * Associa piu uffici ad un utente.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `officeControllerAssociateOfficesToUser()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  officeControllerAssociateOfficesToUser$Response(params: OfficeControllerAssociateOfficesToUser$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: EmptyResponse;
}>> {
    const obs = officeControllerAssociateOfficesToUser(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Associa piu uffici ad un utente.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `officeControllerAssociateOfficesToUser$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  officeControllerAssociateOfficesToUser(params: OfficeControllerAssociateOfficesToUser$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: EmptyResponse;
}> {
    const resp = this.officeControllerAssociateOfficesToUser$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: EmptyResponse;
}>): BaseResponse & {
'data'?: EmptyResponse;
} => r.body)
    );
  }

  /** Path part for operation `officeControllerDissociateOfficesFromUser()` */
  static readonly OfficeControllerDissociateOfficesFromUserPath = '/company/office/associate/user/{id}/offices';

  /**
   * Dissocia piu uffici da un utente.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `officeControllerDissociateOfficesFromUser()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  officeControllerDissociateOfficesFromUser$Response(params: OfficeControllerDissociateOfficesFromUser$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: EmptyResponse;
}>> {
    const obs = officeControllerDissociateOfficesFromUser(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Dissocia piu uffici da un utente.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `officeControllerDissociateOfficesFromUser$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  officeControllerDissociateOfficesFromUser(params: OfficeControllerDissociateOfficesFromUser$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: EmptyResponse;
}> {
    const resp = this.officeControllerDissociateOfficesFromUser$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: EmptyResponse;
}>): BaseResponse & {
'data'?: EmptyResponse;
} => r.body)
    );
  }

  /** Path part for operation `officeControllerFindAllAddressBookByOffice()` */
  static readonly OfficeControllerFindAllAddressBookByOfficePath = '/company/office/addressbook/office/{id}';

  /**
   * Recupera tutti i contatti di un ufficio.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `officeControllerFindAllAddressBookByOffice()` instead.
   *
   * This method doesn't expect any request body.
   */
  officeControllerFindAllAddressBookByOffice$Response(params: OfficeControllerFindAllAddressBookByOffice$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: AddressBookListResponse;
}>> {
    const obs = officeControllerFindAllAddressBookByOffice(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Recupera tutti i contatti di un ufficio.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `officeControllerFindAllAddressBookByOffice$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  officeControllerFindAllAddressBookByOffice(params: OfficeControllerFindAllAddressBookByOffice$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: AddressBookListResponse;
}> {
    const resp = this.officeControllerFindAllAddressBookByOffice$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: AddressBookListResponse;
}>): BaseResponse & {
'data'?: AddressBookListResponse;
} => r.body)
    );
  }

  /** Path part for operation `officeControllerCreateAddressBookOfanoffice()` */
  static readonly OfficeControllerCreateAddressBookOfanofficePath = '/company/office/addressbook/office/{id}';

  /**
   * Crea un contatto di un ufficio.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `officeControllerCreateAddressBookOfanoffice()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  officeControllerCreateAddressBookOfanoffice$Response(params: OfficeControllerCreateAddressBookOfanoffice$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: EmptyResponse;
}>> {
    const obs = officeControllerCreateAddressBookOfanoffice(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Crea un contatto di un ufficio.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `officeControllerCreateAddressBookOfanoffice$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  officeControllerCreateAddressBookOfanoffice(params: OfficeControllerCreateAddressBookOfanoffice$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: EmptyResponse;
}> {
    const resp = this.officeControllerCreateAddressBookOfanoffice$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: EmptyResponse;
}>): BaseResponse & {
'data'?: EmptyResponse;
} => r.body)
    );
  }

  /** Path part for operation `officeControllerFindOneAddressBook()` */
  static readonly OfficeControllerFindOneAddressBookPath = '/company/office/addressbook/{id}';

  /**
   * Recupera un contatto tramite id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `officeControllerFindOneAddressBook()` instead.
   *
   * This method doesn't expect any request body.
   */
  officeControllerFindOneAddressBook$Response(params: OfficeControllerFindOneAddressBook$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: AddressBookItem;
}>> {
    const obs = officeControllerFindOneAddressBook(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Recupera un contatto tramite id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `officeControllerFindOneAddressBook$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  officeControllerFindOneAddressBook(params: OfficeControllerFindOneAddressBook$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: AddressBookItem;
}> {
    const resp = this.officeControllerFindOneAddressBook$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: AddressBookItem;
}>): BaseResponse & {
'data'?: AddressBookItem;
} => r.body)
    );
  }

  /** Path part for operation `officeControllerDeleteAddressBook()` */
  static readonly OfficeControllerDeleteAddressBookPath = '/company/office/addressbook/{id}';

  /**
   * Elimina un contatto di un ufficio.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `officeControllerDeleteAddressBook()` instead.
   *
   * This method doesn't expect any request body.
   */
  officeControllerDeleteAddressBook$Response(params: OfficeControllerDeleteAddressBook$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: EmptyResponse;
}>> {
    const obs = officeControllerDeleteAddressBook(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Elimina un contatto di un ufficio.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `officeControllerDeleteAddressBook$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  officeControllerDeleteAddressBook(params: OfficeControllerDeleteAddressBook$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: EmptyResponse;
}> {
    const resp = this.officeControllerDeleteAddressBook$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: EmptyResponse;
}>): BaseResponse & {
'data'?: EmptyResponse;
} => r.body)
    );
  }

  /** Path part for operation `officeControllerUpdateAddressBook()` */
  static readonly OfficeControllerUpdateAddressBookPath = '/company/office/addressbook/{id}';

  /**
   * Aggiorna un contatto di un ufficio.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `officeControllerUpdateAddressBook()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  officeControllerUpdateAddressBook$Response(params: OfficeControllerUpdateAddressBook$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: EmptyResponse;
}>> {
    const obs = officeControllerUpdateAddressBook(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Aggiorna un contatto di un ufficio.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `officeControllerUpdateAddressBook$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  officeControllerUpdateAddressBook(params: OfficeControllerUpdateAddressBook$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: EmptyResponse;
}> {
    const resp = this.officeControllerUpdateAddressBook$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: EmptyResponse;
}>): BaseResponse & {
'data'?: EmptyResponse;
} => r.body)
    );
  }

}
